/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Builds_Donatekey1Inputs */

const id_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumbangkan Kunci`)
};

const ms_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derma Kunci`)
};

const da_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donér en Nøgle`)
};

const de_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel spenden`)
};

const en_us2_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate a Key`)
};

const es_es2_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donar una clave`)
};

const es_mx2_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donar una llave`)
};

const fil_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-donate ng Key`)
};

const fr_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire don d'une clé`)
};

const it_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona una chiave`)
};

const hu_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs adományozása`)
};

const nl_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doneer een sleutel`)
};

const no_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doner en nøkkel`)
};

const pl_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekaż klucz`)
};

const pt_br2_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate a Key`)
};

const pt_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar uma chave`)
};

const ro_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donează o cheie`)
};

const fi_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahjoita avain`)
};

const sv_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donera en nyckel`)
};

const vi_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyên góp Key`)
};

const tr_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtar Bağışla`)
};

const cs_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darovat klíč`)
};

const bg_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дарете ключ`)
};

const ru_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожертвовать ключ`)
};

const uk_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожертвувати ключ`)
};

const ar_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التبرع بمفتاح`)
};

const hi_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी दान करें`)
};

const th_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บริจาคคีย์`)
};

const ja_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーを寄付`)
};

const zh_cn2_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate a Key`)
};

const zh_hant1_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate a Key`)
};

const ko_table_builds_donatekey1 = /** @type {(inputs: Table_Builds_Donatekey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate a Key`)
};

/**
* | output |
* | --- |
* | "Donate a Key" |
*
* @param {Table_Builds_Donatekey1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_builds_donatekey1 = /** @type {((inputs?: Table_Builds_Donatekey1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Builds_Donatekey1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_builds_donatekey1(inputs)
	if (locale === "ms") return ms_table_builds_donatekey1(inputs)
	if (locale === "da") return da_table_builds_donatekey1(inputs)
	if (locale === "de") return de_table_builds_donatekey1(inputs)
	if (locale === "en-US") return en_us2_table_builds_donatekey1(inputs)
	if (locale === "es-ES") return es_es2_table_builds_donatekey1(inputs)
	if (locale === "es-MX") return es_mx2_table_builds_donatekey1(inputs)
	if (locale === "fil") return fil_table_builds_donatekey1(inputs)
	if (locale === "fr") return fr_table_builds_donatekey1(inputs)
	if (locale === "it") return it_table_builds_donatekey1(inputs)
	if (locale === "hu") return hu_table_builds_donatekey1(inputs)
	if (locale === "nl") return nl_table_builds_donatekey1(inputs)
	if (locale === "no") return no_table_builds_donatekey1(inputs)
	if (locale === "pl") return pl_table_builds_donatekey1(inputs)
	if (locale === "pt-BR") return pt_br2_table_builds_donatekey1(inputs)
	if (locale === "pt") return pt_table_builds_donatekey1(inputs)
	if (locale === "ro") return ro_table_builds_donatekey1(inputs)
	if (locale === "fi") return fi_table_builds_donatekey1(inputs)
	if (locale === "sv") return sv_table_builds_donatekey1(inputs)
	if (locale === "vi") return vi_table_builds_donatekey1(inputs)
	if (locale === "tr") return tr_table_builds_donatekey1(inputs)
	if (locale === "cs") return cs_table_builds_donatekey1(inputs)
	if (locale === "bg") return bg_table_builds_donatekey1(inputs)
	if (locale === "ru") return ru_table_builds_donatekey1(inputs)
	if (locale === "uk") return uk_table_builds_donatekey1(inputs)
	if (locale === "ar") return ar_table_builds_donatekey1(inputs)
	if (locale === "hi") return hi_table_builds_donatekey1(inputs)
	if (locale === "th") return th_table_builds_donatekey1(inputs)
	if (locale === "ja") return ja_table_builds_donatekey1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_builds_donatekey1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_builds_donatekey1(inputs)
	return ko_table_builds_donatekey1(inputs)
});
export { table_builds_donatekey1 as "table.builds.donateKey" }